import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';
import Show from './Show';
import { PackageBillingProvider } from './context';
import { RoutesProvider } from './context/routesContext';
import { showPackageBilling } from '../../config/routes';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function PackageBillings() {
  return (
    <PackageBillingProvider>
      <RoutesProvider>
        <Switch>
          <Route
            exact
            path={showPackageBilling.spec}
            render={(props) => (
              <>
                <Can I="show" a="PackageBillings">
                  {() => <Show {...props} />}
                </Can>
                <Can not I="show" a="PackageBillings">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
          <Route
            render={(props) => (
              <>
                <Can I="list" a="PackageBillings">
                  {() => <List {...props} />}
                </Can>
                <Can not I="list" a="PackageBillings">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
        </Switch>
      </RoutesProvider>
    </PackageBillingProvider>
  );
}
export default React.memo(PackageBillings);
